import CourseCard from '@my-pages/features/courses/components/CourseCard.tsx';
import { MemberBooking } from '@shared/integrations/taf-api/v1/models';
import NoCompletedCourses from './NoCompletedCourses';

interface IProps {
    bookings?: MemberBooking[];
}

const CompletedCoursesCard = ({ bookings }: IProps) => {
    const completedCourses = bookings?.filter((course) => {
        // Check if the course has been participated in
        return course.hasParticipated;
    });
    return (
        <div className='card card-body mb-4'>
            <h3>Genomförda kurser</h3>
            {completedCourses && completedCourses.length > 0 ? (
                <div className='row'>
                    {completedCourses?.map((course, key) => (
                        <CourseCard
                            course={course}
                            key={key}
                        />
                    ))}
                </div>
            ) : (
                <NoCompletedCourses />
            )}
        </div>
    );
};

export default CompletedCoursesCard;
